import useHttpQuery from 'data/firestore/useHttpQuery';
import { useMemo } from 'react';
import ElevenLabs from 'components/icons/elevenlabs';
import { CellWrapper } from '../../columns/styled';
import { AgentContent, ElevenLabsAvatar, StyledWarningIcon } from './styled';

interface ElevenLabsAgent {
    id: string;
    name: string;
    createdAt: number;
}

interface Props {
    value?: string;
    row?: {
        voicePipelineServer: {
            id: string;
        };
    };
}

const VoiceAgentColumn = ({ value, row }: Props) => {
    const { data: response } = useHttpQuery<{ data: ElevenLabsAgent[] }>({
        pathname: '/elevenlabs/agents',
    });
    const agentName = useMemo(() => {
        if (value) {
            let inputValue: ElevenLabsAgent | null | undefined;
            if (typeof value === 'string') {
                inputValue = (response?.data || []).find((agent) => agent.id === value);
            }
            if (inputValue) {
                return inputValue.name;
            }
        }
        return undefined;
    }, [response, value]);

    if (row?.voicePipelineServer?.id !== 'elevenlabs') {
        return <CellWrapper />;
    }

    // Show warning if no value or agent not found
    if (!value || (!agentName && response)) {
        return (
            <CellWrapper>
                <AgentContent>
                    <StyledWarningIcon title="Agent Not Found" />
                    Agent Not Found
                </AgentContent>
            </CellWrapper>
        );
    }

    // Show agent with ElevenLabs logo if found
    if (agentName) {
        return (
            <CellWrapper>
                <AgentContent>
                    <ElevenLabsAvatar>
                        <ElevenLabs />
                    </ElevenLabsAvatar>
                    {agentName}
                </AgentContent>
            </CellWrapper>
        );
    }

    // Loading state - show nothing while waiting for response
    return <CellWrapper />;
};

export default VoiceAgentColumn;
